<template>
  <div class="body">
    <el-alert :closable="false">O QRCODE para pagamento do Pix será gerado na próxima tela</el-alert>
    <img src="/img/payment/qrcode.png" width="200" />
  </div>
</template>

<script>
export default {
  name: 'PaymentPix',
  data() {
    return {
      type: 'pix',
    }
  },
  methods: {
    get() {
      return { type: 'pix' };
    },
    validate() {
      return true;
    }
  }
}
</script>

